import React from 'react';
import PartnerSlider from './components/PartnerSlider';

const Service = () => {
  return (
    <>

<PartnerSlider/>
    <section className="space-bottom overflow-hidden" id="service-sec">
    <div
      className="service-wrap1 space th-radius overflow-hidden"
      data-bg-src="assets/img/bg/gray-bg2.png"
      data-overlay="gray"
      data-opacity={5}
    >
      <div
        className="shape-mockup service-bg-shape1-5 d-xxl-inline-block d-none z-index-3 spin"
        data-top="15%"
        data-left="18%"
      >
        <div className="color-masking">
          <div
            className="masking-src"
            data-mask-src="assets/img/shape/service_shape2_1.png"
          />
          <img src="assets/img/shape/service_shape2_1.png" alt="img" />
        </div>
      </div>
      <div
        className="shape-mockup service-bg-shape1-6 d-xxl-inline-block d-none z-index-3 jump"
        data-bottom="28%"
        data-right="5%"
      >
        <div className="color-masking2">
          <div
            className="masking-src"
            data-mask-src="assets/img/shape/service_shape2_2.png"
          />
          <img src="assets/img/shape/service_shape2_2.png" alt="img" />
        </div>
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7">
            <div className="title-area text-center">
              {/* <span className="sub-title after-none before-none">
                Charity Services
              </span> */}
              <h2 className="sec-title">
                We Do it for all People Humanist Services
              </h2>
            </div>
          </div>
        </div>
        <div className="row gy-30 gx-30 justify-content-center">
          <div className="col-xl-4 col-md-6">
            <div className="service-card style2">
              <div className="box-thumb">
                <img src="assets/img/service/service_card_1_1.png" alt="img" />
              </div>
              <div className="box-icon">
                <img
                  src="assets/img/icon/service-icon/service-card-icon1-1.svg"
                  alt="Icon"
                />
              </div>
              <div className="box-content">
                <h3 className="box-title">
                  <a href="/about">Healthy Foods</a>
                </h3>
                <p className="box-text">
                  Share stories and experiences from current volunteers to
                  inspire others to join. Allow user to sign up for volunteer
                  opportunities.
                </p>
                <a href="/about" className="th-btn">
                  Learn More
                  <i className="fas fa-arrow-up-right ms-2" />
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-md-6">
            <div className="service-card style2">
              <div className="box-thumb">
                <img src="assets/img/service/service_card_1_2.png" alt="img" />
              </div>
              <div className="box-icon">
                <img
                  src="assets/img/icon/service-icon/agicon.png"
                  alt="Icon"
                />
              </div>
              <div className="box-content">
                <h3 className="box-title">
                  <a href="/about">Educations</a>
                </h3>
                <p className="box-text">
                  Explore our charity website to discover impactful projects,
                  opportunities, and ways to donate, helping those in need
                  thrive.
                </p>
                <a href="/about" className="th-btn">
                  Learn More
                  <i className="fas fa-arrow-up-right ms-2" />
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-md-6">
            <div className="service-card style2">
              <div className="box-thumb">
                <img src="assets/img/service/service_card_1_3.png" alt="img" />
              </div>
              <div className="box-icon">
                <img
                  src="assets/img/icon/service-icon/service-card-icon1-3.svg"
                  alt="Icon"
                />
              </div>
              <div className="box-content">
                <h3 className="box-title">
                  <a href="/about">Medical Help</a>
                </h3>
                <p className="box-text">
                  Join us in making a difference! Our charity website connects
                  you with volunteer, donation options, and inspiring stories.
                </p>
                <a href="/about" className="th-btn">
                  Learn More
                  <i className="fas fa-arrow-up-right ms-2" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
     
    </>
  );
};

export default Service;
